
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { ModalServices } from '@/services/ModalServices';
import { StorageServices } from './services/StorageServices';
import { CommonServices } from './services/CommonServices';
import { LoginServices } from './services/LoginServices';
import router from './router';
import { getQueryParams } from '@/utils';
import store from './store';
import { BaseUserClient, LocalizedClient, LoginClient } from './services/Services';
import { mode, appVersion } from './config';
import { LocalizationServices } from './services/LocalizationServices';
import { PushServices } from './services/PushServices';

@Options({})
export default class App extends Vue {

    loading: boolean = true;
    appMode: string = "";
    appVersion: string = "";
    topBarColored: boolean = false;
    ondeBreak: number = 0;

    created(){
        ModalServices.setOpModal(this.$opModal);
        let ondePaddingTop = parseInt(document.documentElement.style.getPropertyValue('--ondeBgPaddingTop'));
        this.ondeBreak = 80 * ondePaddingTop / 192;
    }

    get routeBuster(){
        if(this.$route.meta.routeBuster){
            return new Date().getTime().toString();
        } else {
            return this.$route.name;
        }
    }

    onScroll(ev){
        this.topBarColored = false;
        if(!this.$route.meta.hideTopCut){
            if(this.$refs.appPageContainer){
                if((this.$refs.appPageContainer as HTMLDivElement).scrollTop >= this.ondeBreak){
                    this.topBarColored = true;
                }
            }
        }
        if(store.state.scrollFunction){
            store.state.scrollFunction(ev);
        }
    }

    mounted(){
        this.appMode = mode;
        this.appVersion = appVersion;

        document.addEventListener("deviceready", this.onDeviceReady, false);
        document.addEventListener("pause", this.onPause, false);
        document.addEventListener("resume", this.onResume, false);

        let proms: any[] = [
            LocalizedClient.getAll(),
            LocalizedClient.getEnabledLanguages(),
        ];

        Promise.all(proms)
        .then(xs => {
            store.state.consts.localizedValues = xs[0];
            store.state.consts.enabledLanguages = xs[1];

            if(!store.state.selectedLanguage){
                store.state.selectedLanguage = xs[1][0];
            }


            let jwtParam = getQueryParams()["j"];
            if(jwtParam){
                CommonServices.setAuthToken(jwtParam);
                LoginClient.getLoginDataFromToken()
                .then(x => {
                    LoginServices.loginCallback(x)
                    .then(x => {
                        this.$router.replace('/network/home');
                        this.loading = false;
                    });
                })
            } else if(store.state.loginData && window.location.href.indexOf("/resetPassword/") == -1){
                LoginClient.refreshLogin()
                .then(x => {
                    LoginServices.loginCallback(x)
                    .then(x => {
                        if(x && this.$route.name == 'begin'){
                            let lastVisitedAreaSoci = StorageServices.getLastVisitedAreaSoci();
                            if(lastVisitedAreaSoci){
                                this.$router.replace('/network/home');
                            } else {
                                if(store.state.villageConfig){
                                    this.$router.replace('/village/home');
                                } else {
                                    this.$router.replace('/interlude');
                                }
                            }
                        }
                        this.loading = false
                    });
                })
                .catch(() => this.loading = false)
            } else {
                this.loading = false;
            }
            
        })
        .catch(err => {
            this.loading = false;
        })

    }

    onDeviceReady(){
        store.state.isCordova = true;
        if(Keyboard){
            if(device.platform == "iOS"){
                Keyboard.hideFormAccessoryBar(false);
                // Keyboard.setResizeMode('body');
            }
        }

        this.checkAuthorizations();

        window.cordova.plugins.diagnostic.isRemoteNotificationsEnabled(
            val => store.state.isPushAuthorized = val, 
            err => console.log(err)
        )

        document.addEventListener("backbutton", () => {
            if(store.state.backButtonFunction){
                store.state.backButtonFunction();
            } else {
                if(this.$opModal.modals().length > 0){
                    this.$opModal.closeLast();
                    return;
                }

                if(this.$route.meta.closeAppModal){
                    ModalServices.confirmModal(
                        '',
                        LocalizationServices.GetLocalizedValue('Vuoi chiudere l\'app?', 'Vuoi chiudere l\'app?'),
                        LocalizationServices.GetLocalizedValue('Si', 'Si'),
                        LocalizationServices.GetLocalizedValue('No', 'No'),
                        () => {
                            (<any>window.navigator).app.exitApp();
                        }
                    )
                } else {
                    this.$router.back();
                }
            }
        }, false);


        universalLinks.subscribe(null, (eventData) => {
            // do some work
            console.log(eventData);
            if(eventData.hash){
                this.$router.replace(eventData.hash);
            }
        });

        
        window.addEventListener('keyboardWillShow', (event: any) => {
            document.body.classList.add('keyboardopen');
            // if(device.platform == "Android"){
            //     let root = document.documentElement;
            //     root.style.setProperty('--keyboardHeight', (event).keyboardHeight +  "px");
            // }
        });
        window.addEventListener('keyboardWillHide', (event) => {
            document.body.classList.remove('keyboardopen');
            let pageContainer = document.querySelector('.appPageContainer')
            if(pageContainer.scrollHeight <= window.innerHeight){
                pageContainer.scrollTop = 0;
            }

            // if(device.platform == "Android"){
            //     let root = document.documentElement;
            //     root.style.setProperty('--keyboardHeight', "0px");
            // }
        });
    }

    onPause(){

    }

    onResume(){
        this.checkAuthorizations();
    }

    checkAuthorizations(){
        if(!store.state.user){
            return;
        }
        window.cordova.plugins.diagnostic.isRemoteNotificationsEnabled(
            val => {
                store.state.isPushAuthorized = val;
                if(val){
                    PushServices.register(
                        (token) => {
                            BaseUserClient.saveFcmId({
                                userIdentifier: store.state.user.identifier,
                                fcmId: token
                            })
                        }
                    )
                    .then(x => {
                    });
                }
            }, 
            err => console.log(err)
        )
        // window.cordova.plugins.diagnostic.isCameraAuthorized(
        //     val => store.state.isCameraAuthorized = val,
        //     err => console.log(err),
        //     true
        // )
        // window.cordova.plugins.diagnostic.getCameraAuthorizationStatuses(
        //     statuses => store.state.isCameraAuthorized = statuses.CAMERA == window.cordova.plugins.diagnostic.permissionStatus.GRANTED,
        //     err => console.log(err),
        //     true
        // )
    }

}
